import '@/css/chat.less';

import './src/butfly';

import Vue from 'vue';
import ChatWindow from './chat.vue';
import Chat from './src/chat';
import Settings from './src/settings';
import UserActivity from './src/useractivity';
import PageIcon from './src/pageicon';
import eventBus from './eventbus';

document.addEventListener('DOMContentLoaded', () => {
	eventBus.state.baseDomain = location.host.split('.').slice(1).join('.');

	let root = new Vue({
		el: '#chat-window',
		render: h => h(ChatWindow),
	});

	Chat.init();
	Chat.address = 'wss://sinair.net/ws/chat';

	setTimeout(Chat.connect.bind(Chat), 250);
	UserActivity.init();
	PageIcon.init();

	global.eventBus = eventBus;
	global.Chat = Chat;

	if (!('WebSocket' in window)){
		alert('Чат недоступен на вашем устройстве: ваш браузер не поддерживает технологию WebSocket.');
		return;
	}

	document.addEventListener('keydown', (e) => {
		if (
			!e.ctrlKey && !e.altKey && !e.metaKey
			&& !(e.keyCode >= 33 && e.keyCode <= 40) // arrows, home, end, pgUp, pgDown
			&& !e.target.matches('input,textarea')
		) {
			eventBus.$emit('setFocusToMessageInput');
		}
	});

	if (!('chatSettings' in localStorage)){
		Chat.firstRun();
	}

	window.addEventListener('beforeunload', e => {
		if (Settings.confirmPageClose) {
			e.returnValue = 'confirm';
		}
	});
});
